import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { loanEditMock } from './mocks/loan-edit.mock';
var apiUrl = env.VITE_API_URL;
export var loanEditHandler = [
    http.patch("".concat(apiUrl, "/loan/edit"), function () {
        return HttpResponse.json(loanEditMock.success);
    }),
];
